import { render, staticRenderFns } from "./setting-profilePreferences.vue?vue&type=template&id=01abe8ce&scoped=true&"
import script from "./setting-profilePreferences.vue?vue&type=script&lang=js&"
export * from "./setting-profilePreferences.vue?vue&type=script&lang=js&"
import style0 from "./setting-profilePreferences.vue?vue&type=style&index=0&id=01abe8ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01abe8ce",
  null
  
)

export default component.exports